export default __webpack_public_path__ + "static/media/circle_blue.bbea9753.png";